import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnMY: CultureInfo = {
  name: 'en-MY',
  displayName: 'English (Malaysia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-MY',
  parent: CultureInfoEn
};
